import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import { StandardProductModalFooter } from "./components/StandardProductModalFooter/StandardProductModalFooter";
import { StandardProductListColumn } from "./components/StandardProductListColumn.tsx/StandardProductListColumn";
import { StandardProductColumn } from "./components/StandardProductColumn.tsx/StandardProductColumn";

interface StandardProductModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  product: CategoryStandardProduct;
  totalPrice: string;
  monthlyPayment: number;
}

export default function StandardProductModalDialog({
  product,
  isOpen,
  setIsOpen,
  totalPrice,
  monthlyPayment,
}: StandardProductModalProps) {
  return (
    <Transition as={Dialog} show={isOpen} onClose={() => setIsOpen(false)}>
      <Transition.Child
        as={Fragment}
        enter="gg-ease-out gg-duration-300"
        enterFrom="gg-opacity-0 gg-scale-95"
        enterTo="gg-opacity-100 gg-scale-100"
        leave="gg-ease-in gg-duration-100"
        leaveFrom="gg-opacity-100 gg-scale-100"
        leaveTo="gg-opacity-0 gg-scale-95"
      >
        <div className="gg-fixed gg-left-0 gg-top-0 gg-z-50 gg-grid gg-h-full gg-w-screen gg-place-items-center gg-overflow-x-hidden gg-backdrop-blur-md lg:gg-inset-0 lg:gg-h-auto">
          <Dialog.Panel className="gg-grid gg-h-full gg-w-full gg-grid-cols-9 gg-rounded-sm gg-bg-white gg-shadow-lg lg:gg-h-auto xl:gg-max-w-5xl">
            {/* column 1 with product */}
            <StandardProductColumn
              product={product}
              totalPrice={totalPrice}
              monthlyPayment={monthlyPayment}
            />
            {/* column 1 with product */}

            {/* column 2 with random products */}
            <StandardProductListColumn />
            {/* column 2 with random products end */}

            {/* FOOTER  */}
            <StandardProductModalFooter setIsOpen={setIsOpen} />

            {/* FOOTER  END*/}

            {/* navbar column */}
          </Dialog.Panel>
        </div>
      </Transition.Child>
    </Transition>
  );
}
